import { ComponentType } from "react";
import { PersonLastNameFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/**
 * Фамилия человека отдельным полем: в анкете части имени показываются по одной, а
 * сама фамилия — локализованное значение и может быть закрыто защитой.
 */
export function PersonLastName({
  data,
  whenEmpty,
}: {
  data?: Hidable<PersonLastNameFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(person) => (
        <LocalizedName data={person.lastName} whenEmpty={whenEmpty} />
      )}
    </Value>
  );
}
